export default "__VITE_ASSET__DPfDO49F__"